import React, { useEffect, useMemo } from 'react';

const bedtimeStyles = `
  @keyframes twinkle {
    0%, 100% { opacity: 0.2; }
    50% { opacity: 0.9; }
  }
  .bedtime-star {
    position: absolute;
    border-radius: 50%;
    background: white;
    pointer-events: none;
  }
  .bedtime-overlay-close-btn:hover {
    background: rgba(255,255,255,0.3) !important;
  }
`;

function generateStars(count) {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    top: Math.random() * 100,
    left: Math.random() * 100,
    size: Math.random() * 3 + 1.5,
    delay: Math.random() * 4,
    duration: 1.5 + Math.random() * 2.5,
    color: Math.random() > 0.7 ? '#c4b0f8' : 'white',
  }));
}

const BedtimeCard = ({ story, childName, streak, onClose, reflectionPrompts }) => {
  const stars = useMemo(() => generateStars(20), []);

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose && onClose();
    }, 30000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <>
      <style>{bedtimeStyles}</style>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 5000,
          background: 'linear-gradient(135deg, #0f0b1e 0%, #1a1438 50%, #0a0618 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {stars.map((star) => (
          <div
            key={star.id}
            className="bedtime-star"
            style={{
              top: `${star.top}%`,
              left: `${star.left}%`,
              width: `${star.size}px`,
              height: `${star.size}px`,
              background: star.color,
              animation: `twinkle ${star.duration}s ${star.delay}s ease-in-out infinite`,
            }}
          />
        ))}

        <div
          style={{
            position: 'relative',
            zIndex: 1,
            textAlign: 'center',
            padding: '32px 24px',
            maxWidth: '480px',
            width: '100%',
          }}
        >
          <div style={{ fontSize: '64px', lineHeight: 1, marginBottom: '16px' }}>🌙</div>

          <h2
            style={{
              fontFamily: "'Fredoka One', cursive",
              fontSize: '28px',
              color: 'white',
              marginBottom: '8px',
            }}
          >
            You read together tonight 🌙
          </h2>

          {story?.title && (
            <p
              style={{
                fontSize: '16px',
                fontStyle: 'italic',
                color: '#c4b0f8',
                marginBottom: '16px',
              }}
            >
              "{story.title}"
            </p>
          )}

          {streak > 0 && (
            <div
              className="d-inline-block rounded-pill px-3 py-1 mb-4"
              style={{
                background: 'rgba(255,255,255,0.12)',
                color: 'white',
                fontSize: '15px',
                border: '1px solid rgba(255,255,255,0.2)',
              }}
            >
              🔥 {streak}-night streak!
            </div>
          )}

          {reflectionPrompts && reflectionPrompts.length > 0 && (
            <div
              className="rounded-3 p-3 mb-4"
              style={{
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.15)',
                textAlign: 'left',
              }}
            >
              <div style={{ color: '#c4b0f8', fontSize: '13px', fontWeight: 600, marginBottom: '8px' }}>
                💬 Ask {childName || 'your child'} tonight:
              </div>
              {reflectionPrompts.slice(0, 2).map((prompt, idx) => (
                <div
                  key={idx}
                  className="rounded-3 p-2 mb-2"
                  style={{
                    background: 'rgba(255,255,255,0.06)',
                    color: 'rgba(255,255,255,0.85)',
                    fontSize: '13px',
                  }}
                >
                  💭 {prompt}
                </div>
              ))}
            </div>
          )}

          <button
            className="btn rounded-pill px-4 py-2 bedtime-overlay-close-btn"
            style={{
              background: 'rgba(255,255,255,0.18)',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.3)',
              fontSize: '15px',
              transition: 'background 0.2s ease',
            }}
            onClick={onClose}
          >
            Close & Sleep Well 🌛
          </button>
        </div>
      </div>
    </>
  );
};

export default BedtimeCard;
